import React, {useEffect, useState} from 'react'
import styled, {css} from 'styled-components'
import PropTypes from 'prop-types'
import {buttonStyles} from '../../buttons/button'
import {Snackbar as RmwcSnackbar} from '@rmwc/snackbar'
import '@rmwc/snackbar/styles'

export const snackbarStyles = ({selector = '&&&'}) => css`
  ${selector} .mdc-snackbar__surface {
    background-color: var(--mdc-theme-primary);
  }
  ${selector}.mdc-snackbar--stacked .mdc-snackbar__surface > .rmwc-icon {
    margin-top: 1rem;
  }
  ${selector} .mdc-snackbar__label {
    font-family: 'Open Sans', sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.1px;
  }
  ${buttonStyles({selector: '&&& .mdc-snackbar__action.mdc-button'})}
  &&& .mdc-snackbar__action:not(:disabled) {
    color: var(--mdc-theme-primary3);
  }
`

const StyledRmwcSnackbar = styled(RmwcSnackbar)`
  ${snackbarStyles}
`

const Snackbar = ({message, handleRemoveMessage, leading, timeout, dismissesOnAction, ...otherProps}) => {
  const [isOpen, setIsOpen] = useState(false)
  useEffect(() => {
    if (!isOpen && message) {
      setIsOpen(true)
    }
  }, [message])

  return (
    <StyledRmwcSnackbar
      open={isOpen}
      onClose={() => {
        handleRemoveMessage()
        setIsOpen(false)
      }}
      message={message}
      leading={leading}
      timeout={timeout}
      dismissesOnAction={dismissesOnAction}
      {...otherProps}
    />
  )
}

Snackbar.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  handleRemoveMessage: PropTypes.func.isRequired,
  action: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  dismissIcon: PropTypes.bool,
  dismissesOnAction: PropTypes.bool,
  leading: PropTypes.bool,
  stacked: PropTypes.bool,
  timeout: PropTypes.number
}

Snackbar.defaultProps = {
  dismissesOnAction: true,
  leading: true,
  timeout: 4000
}

export {Snackbar}
